import React from "react";
import PropTypes from "prop-types";

// styles
import {
    TagListStyled,
    TagListItemStyled,
    CheckboxStyled,
    TagStyled
} from "./styles.js";
import colors from "core/colors";

// components
import Checkbox from "core/Checkbox";
import { TagRemoveable } from "frontend/components/core/Tag/TagRemoveable";

// QueueContext
import { useQueueContext } from "frontend/components/fort/mod/core/Layouts/QueueLayout";

const TagList = ({ tags, title, onTagApprove, onTagRemove, isEditable }) => {
    return (
        <TagListStyled>
            <h4>
                {title} ({tags.length})
            </h4>
            {tags.map(tag => {
                return (
                    <TagListItem
                        key={tag.id}
                        tag={tag}
                        onTagApprove={onTagApprove}
                        onTagRemove={onTagRemove}
                        isEditable={isEditable}
                    />
                );
            })}
        </TagListStyled>
    );
};

// prop-types
TagList.propTypes = {
    tags: PropTypes.array,
    title: PropTypes.string.isRequired,
    onTagApprove: PropTypes.func.isRequired,
    onTagRemove: PropTypes.func.isRequired,
    isEditable: PropTypes.bool
};

const TagListItem = ({ tag, onTagApprove, onTagRemove, isEditable }) => {
    // state/context
    const {
        state: { singleUploadSelected }
    } = useQueueContext();

    const { name, isApproved, hasWarning } = tag;

    const handleApprove = () => {
        onTagApprove({ uploadId: singleUploadSelected.id, tag });
    };
    const handleRemove = () => {
        onTagRemove({ uploadId: singleUploadSelected.id, tag });
    };

    return (
        <TagListItemStyled
            data-testid={isApproved ? `mod-tag-approved` : `mod-tag-pending`}
        >
            <CheckboxStyled>
                <Checkbox
                    onClick={handleApprove}
                    isChecked={isApproved}
                    isDisabled={!isEditable}
                    checkboxStyles={{
                        default: colors.primary.snow,
                        checked: colors.alternative.lightMode.shamrock,
                        disabled: colors.secondary.dolphin
                    }}
                />
            </CheckboxStyled>
            <TagStyled>
                <TagRemoveable
                    onClick={handleRemove}
                    text={name}
                    ariaLabel={name}
                    hasWarning={hasWarning}
                    isDisabled={!isEditable}
                />
            </TagStyled>
        </TagListItemStyled>
    );
};

export default TagList;
// prop-types
TagListItem.propTypes = {
    tag: PropTypes.object.isRequired,
    onTagApprove: PropTypes.func.isRequired,
    onTagRemove: PropTypes.func.isRequired,
    isEditable: PropTypes.bool
};
